import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Navbar } from "react-bootstrap";

import "./styles.scss";

const Toggle = ({ className, ...restProps }) => {
  return (
    <Navbar.Toggle
      className={classNames("mydpd-navbar-toggler border-0", className)}
      {...restProps}
    />
  );
};

Toggle.propTypes = {
  className: PropTypes.string,
  ...Navbar.Toggle.propTypes,
};

export default Toggle;
